<template>
  <div>
    <adv-button
      class="quickViewBtn"
      v-on:btn-click="toggleQuickView"
      :productId="this.productId"
      v-show="showQuickView">
      <i class="ti-zoom-in"></i>
    </adv-button>

    <adv-button
      v-if="hasAttributes"
      class="addtoCart"
      :productId="this.productId"
      v-on:btn-click="toggleQuickView"
      v-show="showAddToCart"
      v-html="buttonBuyText">
    </adv-button>

    <adv-cart-button
      v-else
      :quantity="quantity"
      :stock="stock"
      :productId="this.productId"
      v-on:btn-click="btnBuyClicked"
      v-on:btn-click-no-stock="btnBuyClickedNoStock"
      :progress="progress"
      v-show="showAddToCart"
      :cart-limit-reached="cartLimitForProductReached"
      :disabled="setDisabled || cartLimitForProductReached"></adv-cart-button>
  </div>
</template>

<script>
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import onlineMixin from './mixins/onlineMixin'
import cartButtonMixin from './mixins/cartButtonMixin'
import AdvButton from './presentation/AdvButton'
import AdvCartButton from './AdvCartButton'

export default {
  name: 'AdvButtonViewBuy',
  mixins: [productMixin, onlineMixin, cartButtonMixin],
  props: {
    productId: {
      type: Number,
      default: null
    },
    showImage: {
      type: Boolean,
      default: true
    },
    showName: {
      type: Boolean,
      default: true
    },
    showContent: {
      type: Boolean,
      default: true
    },
    showQuickView: {
      type: Boolean,
      default: false
    },
    showAddToCart: {
      type: Boolean,
      default: true
    },
    recommendationType: {
      type: String,
      default: null
    },
    recommendationId: {
      type: String,
      default: null
    }
  },
  components: {
    AdvCartButton,
    AdvButton
  },
  data () {
    return {
      version: '0.0.1',
      quickViewVisible: false,
      progress: false
    }
  },
  computed: {
    setDisabled () {
      return this.stock <= 0 || !this.onlineStatus
    },
    quantity () {
      return store.getters.cartProductCodeQuantity(this.productData.productCodes[0].productCodeId)
    },
    cartQuantity () {
      return this.$store.getters.cartProductCodeQuantity(this.productCodeId, 0)
    },
    cartLimitForProductReached () {
      return this.stock === this.quantity - 1
    },
    hasAttributes () {
      return this.productData.productCodes.length > 1
    },
    quickViewButtonVisible () {
      return store.getters.productCardModal.open
    },
    stock () {
      return this.productData.productStock
    },
    buttonBuyText () {
      if (this.stock <= 0) {
        return this.t('product_status.unavailable.coming_soon')
      }

      return `<i class="ti-shopping-cart"></i> ${this.t('add_to_cart')}`
    }
  },
  methods: {
    toggleQuickView () {
      if (store.state.productCardModal.open) {
        store.dispatch('closeProductCardModal')
      } else {
        store.dispatch('openProductCardModal', this.productId)
      }
    },
    btnBuyClicked () {
      this.progress = true
      store.dispatch(
        'addToCartClicked',
        {
          productCodeId: this.productData.productCodes[0].productCodeId,
          quantity: this.quantity,
          recommendationType: this.recommendationType,
          recommendationId: this.recommendationId
        }
      )
        .then(() => {
          this.progress = false
        })
    },
    btnBuyClickedNoStock () {
      // for clients that need click event without stock on button
    }
  }
}
</script>
